import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpRequestOptions, ProductDetermination} from '@dcp/configurator';
import {Observable, throwError} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {DcpKymaService} from './dcp-kyma.service';
@Injectable({
  providedIn: 'root',
})
export class DcpCtaValidationService {
  constructor(private http: HttpClient, private kymaService: DcpKymaService) {}

  getCtaValidation(
    userId: string,
    id: string,
    cta: string,
    technicalName: string = '',
    accountId?: string,
    languageIso?: string
  ): Observable<ProductDetermination> {
    const body = {
      technicalName,
      userId,
      ctaForEntitlement: {
        id,
        cta,
      },
      ...(accountId && {accountId}),
      ...(languageIso && {languageIso}),
    };
    return this.kymaService
      .prepareAuthConfig()
      .pipe(
        concatMap((config: HttpRequestOptions) =>
          this.http.post<ProductDetermination>(`${this.kymaService.getUrl('transaction')}/cta-validation`, body, config)
        )
      );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
